import { action, observable } from "mobx"
import shop from "shop/shop"
import languageStore from "stores/languageStore"
import convertBoolean from "util/convertBoolean"

// import _ from "lodash"

class CategoryStore {

  @observable categories = []
  @observable categoriesById = new Map()
  @observable hasFilter = false

  @action fetch() {
    const { currentLanguage } = languageStore
    return shop.fetch( `/shop/rest/data/categories/tree?lang=${currentLanguage}`, {
      credentials: "include",
      mode:        "cors",
    } )
      .then( categories => {
        categories = convertBoolean( categories )
        this.categories = this.mapCategories( categories )
        return this.categories
      } )
      .catch( err => {
        console.error( "Error fetching categories", err )
      } )
  }

  @action
  showFilter() {
    this.hasFilter = true
  }

  @action
  hideFilter() {
    this.hasFilter = false
  }

  mapCategories = ( categories ) => {
    return categories.map( data => {
      let category = new shop.CategoryModel( data )
      category.children = this.mapCategories( category.children )
      this.categoriesById.set( category.map_id, category )
      return category
    } )
  }

}

const categoryStore = new CategoryStore()
window.categoryStore = categoryStore

export default categoryStore



// WEBPACK FOOTER //
// ./src/sdk/store/CategoryStore.js